import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, hideElement, displayElement, isVisible } from '@fretadao/f-js-dom';
import { formatNumberAsBRLCurrency } from 'src/currency';
import moment from 'moment';

application.register('table-filter', class extends Controller {
  static values = {
    filterCol: Number,
    filter: String
  };

  connect() {
    this.monthFilter();
  }

  filter() {
    if(this.filterValue === 'month') {
      this.monthFilter();
    }
    else if(this.filterValue === 'plan') {
      this.filterByPlan();
    }
    else {
      this.filterTable();
    }
  }

  monthFilter() {
    const filterDate = moment(find('[data-filter="date"]').getAttribute('data-filter-date'));
    const dateCol = parseInt(find('[data-element="table"]').getAttribute('data-col-date'));
    const planCol = parseInt(find('[data-element="table"]').getAttribute('data-col-plan'));

    if(this.filterColValue === planCol)
      this.filterColValue = dateCol

    this.getTableRows().forEach((row) => {
      let date = row.cells[this.filterColValue] ? moment(row.cells[this.filterColValue].innerHTML, 'DD-MM-YYYY') : null;
      if (date && ((date.month() != filterDate.month()) || (filterDate.year() != date.year()))) {
        hideElement(row)
      }
      else {
        displayElement(row, 'table-row')
      }
    });

    this.filterColValue = planCol
    this.applyPlanFilterToRows(this.getTableRows(), find('[data-option]:checked').value)

    this.updateTotalValue()
  }

  filterByPlan() {
    const testableValue = find('[data-option]:checked').value;
    const tableRows = this.getTableRows();

    this.monthFilter();
    this.applyPlanFilterToRows(tableRows, testableValue);
    this.updateTotalValue();
  }

  applyPlanFilterToRows(tableRows, testableValue) {
    if (testableValue === 'all') {
      tableRows.forEach((row) => {
        if (isVisible(row)) {
          displayElement(row, 'table-row');
        }
      });
    }
    else {
      this.filterTable(tableRows, testableValue);
    }
  }

  filterTable(tableRows, testableValue) {
    tableRows.forEach((row) => {
      if (isVisible(row)) {
        (row.cells[this.filterColValue].getAttribute('data-direction') === testableValue) ?
          displayElement(row, 'table-row') :
          hideElement(row);
      }
    });
  }

  updateTotalValue() {
    const tableRows = this.getTableRows();
    const totalValueCell = find('[data-element="totalValueCell"]');
    const totalValueCol = parseInt(find('[data-element="table"]').getAttribute('data-total-value-col'));
    let totalValue = 0;

    tableRows.forEach((row) => {
      if (isVisible(row)) {
        totalValue += parseFloat(row.cells[totalValueCol].innerHTML.split('R$ ')[1].replace(',', '.'))
      }
    });

    totalValueCell.innerHTML = formatNumberAsBRLCurrency(totalValue);
  }

  getTableRows() {
    const table = find('[data-element="table"]');
    const tableBody = table.tBodies[0];
    return Array.prototype.slice.call(tableBody.rows, 0);
  }
});
